import AbsSection from '../AbsSection';

import YTplayer from '../../common/YTplayer';
import AppTmpl from './AppTmpl';

import PlayList from './PlayListManager';
import Recommend from './Recommend';
import Info from './Info';
import BtnPlayPause from './BtnPlayPause';
import BtnVolume from './BtnVolume';
import Timeline from './Timeline';
import Duration from './Duration';
import NoMovieVisual from './NoMovieVisual';

export default class App extends AbsSection{
    constructor(_dataM={}, _option={}){
        super('', _dataM, _option, 'moviePlayer');

        this.nameIs = 'class-MoviePlayer Main App';
        this.timer = null;

        if( this.isShow ) {
            this.dataM.addManual('moviePlayer', this.com.ip + '-main-recom');
        } else {
            $('section.main-movie .main-movie-visual').addClass('is-active');
            this.noMovie = new NoMovieVisual('section.main-movie .main-movie-visual', this.option);
        }
    }

    setTemplate(){
        this.option = {
            isShow: true,
            vod_iframe_id: 'video_ifame_'+(+new Date())+parseInt( Math.random()*1000000 ),
            el_sel: 'section.main-movie',
            list: this.dataM.data.moviePlayer
        };

        this.moviePlayerSetting();
    }

    moviePlayerSetting(){
        $('section.main-movie .main-movie-player').addClass('is-active');
        // $('section.main-movie .main-movie-recommend').addClass('is-active');
        $('section.main-movie .main-movie-player').html( AppTmpl(this.option.vod_iframe_id) );

        this.playList = new PlayList( this.option );
        this.recommend = new Recommend(this.option.el_sel + ' .main-movie-recommend', this.option);
        this.info = new Info(this.option.el_sel + ' .main-movie-player .player-info', this.option);
        this.playPause = new BtnPlayPause(this.option.el_sel + ' .main-movie-player .player-controlbar-wapper .player-controlbar .controlbar-buttons', this.option);
        this.volume = new BtnVolume(this.option.el_sel + ' .main-movie-player .player-controlbar-wapper .player-controlbar .controlbar-buttons', this.option);

        this.timeline = new Timeline(this.option.el_sel + ' .main-movie-player .player-controlbar-wapper .player-controlbar .controlbar-progress', this.option);
        this.duration = new Duration(this.option.el_sel + ' .main-movie-player .player-controlbar-wapper .player-controlbar .controlbar-time', this.option);

        this.moviePlayer = new YTplayer({
            el_sel: this.option.el_sel,
            el_id: this.option.vod_iframe_id,
            videoId: this.option.list[0].youtubeId,
            width: '100%', height: '100%',
            playerVars: {
                mute: true,
                start: this.option.list[0].startSeconds,
                autoplay: 1,
            }
        });
    }

    setEvents(){
        $(this.option.el_sel).on( 'PLAYER_INIT_COMP', (e)=>{
            $(this.option.el_sel + ' .ui-player-video').show();
            TweenMax.to($(this.option.el_sel + ' .ui-player-video'), 0.7, {css:{opacity:1}});
            this.moviePlayer.volume = 50;
        });

        $(this.option.el_sel).on( 'PLAYER_END', (e)=>{
            this.playPause.pause();
            clearTimeout(this.timer);
        });

        $(this.option.el_sel).on( 'PLAYER_PLAY', (e)=>{
            this.playPause.play();
            this.timerGo();
        });

        $(this.option.el_sel).on( 'PLAYER_PAUSE', (e)=>{
            this.playPause.pause();
            clearTimeout(this.timer);
        });

        $(this.option.el_sel).on( 'PLAYER_BUFFERING', (e)=>{
            this.playPause.pause();
            clearTimeout(this.timer);
        });

        $(this.option.el_sel).on( 'PLAYER_READY', (e)=>{
            this.playPause.pause();
            clearTimeout(this.timer);
        });

        $(this.option.el_sel).on( 'PLAYER_MUTE', (e)=>{
            this.volume.mute();
        });

        $(this.option.el_sel).on( 'PLAYER_UNMUTE', (e)=>{
            this.volume.unMute();
            this.volume.volumeUpdate( this.moviePlayer.volume );
        });

        $(this.option.el_sel).on( 'PLAYER_VOLUME', (e)=>{
            this.volume.volumeUpdate( this.moviePlayer.volume );
        });

        $(this.option.el_sel).on( 'PLAYER_SEEK', (e)=>{
            console.log( this.moviePlayer.time );
        });

        $(this.option.el_sel).on( 'PLAY_BTN_CLICK', (e)=>{
            if(this.moviePlayer.time >= this.playList.nowVodData.endSeconds){
                this.playList.next();
                this.nextPlay();
            } else {
                this.moviePlayer.play();
            }
        });

        $(this.option.el_sel).on( 'PAUSE_BTN_CLICK', (e)=>{
            this.moviePlayer.pause();
        });

        $(this.option.el_sel).on( 'SOUNDON_BTN_CLICK', (e)=>{
            this.moviePlayer.mute();
        });

        $(this.option.el_sel).on( 'SOUNDOFF_BTN_CLICK', (e)=>{
            this.moviePlayer.unMute();
        });

        $(this.option.el_sel).on( 'VOLUME_CHANGE', (e)=>{
            this.moviePlayer.volume = e.vol;
        });

        $(this.option.el_sel).on( 'TIMELINE_CHANGE', (e)=>{
            this.moviePlayer.time = e.time;
        });

        $(this.option.el_sel).on( 'REACH_END_TIME', (e)=>{
            this.moviePlayer.pause();
            clearTimeout(this.timer);
            this.nextPlay();
        });

        $(this.option.el_sel).on( 'RECOMMEND_CHANGE', (e)=>{
            this.moviePlayer.pause();
            clearTimeout(this.timer);
            this.playList.go(e.idx);
            this.nextPlay();
        });

        $(this.option.el_sel).on( 'RECOMMEND_OPEN', (e)=>{
            this.moviePlayer.pause();
            // TweenMax.to(this.option.el_sel + ' .main-movie-player', 0.2, {webkitFilter:"blur(7px)"});
        });

        $(this.option.el_sel).on( 'RECOMMEND_CLOSE', (e)=>{
            if(this.moviePlayer.time >= this.playList.nowVodData.endSeconds){
                this.playList.next();
                this.nextPlay();
            } else {
                this.moviePlayer.play();
            }
            // TweenMax.to(this.option.el_sel + ' .main-movie-player', 0.1, {webkitFilter:"blur(0px)"});
        });

        this.recommend.addEvents();
        this.info.addEvents();
        this.playPause.addEvents();
        this.volume.addEvents();
        this.timeline.addEvents();
        this.duration.addEvents();
    }

    nextPlay(){
        const nextData = this.playList.nowVodData;
        this.info.update( nextData );
        this.timeline.setNowVideoData( nextData );
        this.duration.setNowVideoData( nextData );
        this.moviePlayer.nextPlay({
            videoId: nextData.videoId, 
            startSeconds: nextData.startSeconds, 
            endSeconds: nextData.endSeconds + 0.1
        });
    }

    timerGo(){
        this.timer = setTimeout(() => {
            this.timeline.update( this.moviePlayer.duration, this.moviePlayer.time );
            this.duration.update( this.moviePlayer.duration, this.moviePlayer.time );
            this.playList.update( this.moviePlayer.duration, this.moviePlayer.time );
            this.timerGo();
        }, 30);
    }

} // end of class
